import moment from 'moment';

export const Getters = {
  // implement getters here...

  getTelemetryActiveInfo(state) {
    return state.telemetryActiveInfo;
  },
  chartDataset: state => chartName => state[chartName],
  gridItemRowHeight: state => state.config.gridItemRowHeight,
  getCoordinatorUtilizationChartFilters: state => state.coordinatorUtilizationChartFilters,
  getCoordinatorUtilizationChart: state => {
    const tempHolder = state.coordinatorUtilizationChart;
    tempHolder.data.datasets[0].data = state.coordinatorUtilizationChart0;
    tempHolder.data.datasets[1].data = state.coordinatorUtilizationChart1;
    tempHolder.data.datasets[2].data = state.coordinatorUtilizationChart2;
    tempHolder.data.datasets[3].data = state.coordinatorUtilizationChart3;
    if (state.coordinatorUtilizationChartFilters.stackedChart) {
      tempHolder.data.datasets[3].data = state.coordinatorUtilizationChart3stacked;
    }
    state.coordinatorUtilizationChart.data.labels.forEach((label, index) => {
      tempHolder.data.labels[index] = moment.unix(label).format('h:mm A'); // future wishlist - make this offset based on requested timezone.
    });
    return tempHolder;
  },
  getDailyCoresUsageChartFilters: state => state.dailyCoresUsageChartFilters,
  getWorkloadUtilizationFilters: state => state.slide4Filters,
  getWorkloadByFilters: state => state.slide5Filters,
  getAgentsUtilizationFilters: state => state.agentsUtilizationChartFilters,
  getBuildsDurationChart: state => {
    const slideObj = {
      maxCaptionAvgDuration: 1,
      maxCaptionWorkloads: 1,
      maxAgentAvgDuration: 1,
      maxAgentWorkloads: 1,
      byCaption: [],
      byAgent: [],
    };
    if (state.workloadsByDataset && state.workloadsByDataset.builds && Object.keys(state.workloadsByDataset.builds) && Object.keys(state.workloadsByDataset.builds).length > 0) {
      const { builds } = state.workloadsByDataset;
      const byCaption = {};
      const byAgent = {};
      Object.keys(builds).forEach(x => {
        const capt = builds[x].Caption; // || 'No Caption';
        const agent = builds[x].InitiatorName; // || 'No Initiator';
        // filter records
        if (!(state.slide5Filters.build_captions.length === 0 || state.slide5Filters.build_captions.includes('All')) && capt && !state.slide5Filters.build_captions.includes(capt)) return;
        if (!(state.slide5Filters.agent_names.length === 0 || state.slide5Filters.agent_names.includes('All')) && agent && !state.slide5Filters.agent_names.includes(agent)) return;
        // aggregate captions
        if (capt) {
          if (!byCaption[capt]) {
            byCaption[capt] = {
              key: capt,
              Duration: 0,
              Executions: 0,
              builds: [],
              agents: [],
            };
          }
          byCaption[capt].Duration += builds[x].Duration;
          byCaption[capt].Executions++;
          byCaption[capt].builds.push(x);
          if (agent && !byCaption[capt].agents.includes(agent)) byCaption[capt].agents.push(agent);
        }
        // aggregate agents
        if (agent) {
          if (!byAgent[agent]) {
            byAgent[agent] = {
              key: agent,
              Duration: 0,
              Executions: 0,
              builds: [],
              captions: [],
            };
          }
          byAgent[agent].Duration += builds[x].Duration;
          byAgent[agent].Executions++;
          byAgent[agent].builds.push(x);
          if (capt && !byAgent[agent].captions.includes(capt)) byAgent[agent].captions.push(capt);
        }
      });
      if (byCaption && Object.keys(byCaption).length > 0) {
        Object.keys(byCaption).forEach(x => {
          byCaption[x].Duration = Math.floor(byCaption[x].Duration / byCaption[x].Executions); // make it avg
          slideObj.byCaption.push(byCaption[x]);
          if (byCaption[x].Duration > slideObj.maxCaptionAvgDuration) slideObj.maxCaptionAvgDuration = byCaption[x].Duration;
          if (byCaption[x].Executions > slideObj.maxCaptionWorkloads) slideObj.maxCaptionWorkloads = byCaption[x].Executions;
        });
      }
      if (byAgent && Object.keys(byAgent).length > 0) {
        Object.keys(byAgent).forEach(x => {
          byAgent[x].Duration = Math.floor(byAgent[x].Duration / byAgent[x].Executions); // make it avg
          slideObj.byAgent.push(byAgent[x]);
          if (byAgent[x].Duration > slideObj.maxAgentAvgDuration) slideObj.maxAgentAvgDuration = byAgent[x].Duration;
          if (byAgent[x].Executions > slideObj.maxAgentWorkloads) slideObj.maxAgentWorkloads = byAgent[x].Executions;
        });
      }
    }
    return slideObj;
  },
  getBuildsDurationChartDataRaw: state => state.workloadsByDataset,
  getAgentsUtilizationChart: state => {
    if (!state.agentsUtilizationChart || !state.agentsUtilizationChart.agentsList) return [];
    // if all filters are empty, just return it directly - add other filters once needed.
    let filteredList = state.agentsUtilizationChart.agentsList.slice();
    if (
      Array.isArray(state.agentsUtilizationChartFilters.agent_names) &&
      state.agentsUtilizationChartFilters.agent_names.length > 0 &&
      !state.agentsUtilizationChartFilters.agent_names.includes('All')
    )
      filteredList = filteredList.filter(x => state.agentsUtilizationChartFilters.agent_names.includes(x.agent));
    // add other filters here.
    return filteredList;
  },
};

// use this if we finnally dump moment.
// function formatTimeAMPM(date) {
//   let hours = date.getHours();
//   let minutes = date.getMinutes();
//   const ampm = hours >= 12 ? 'PM' : 'AM';
//   hours = hours % 12;
//   hours = hours ? hours : 12; // the hour '0' should be '12'
//   minutes = minutes < 10 ? '0'+minutes : minutes;
//   return `${hours}:${minutes} ${ampm}`
// }
